/**
 * Template: Customers
 * -----------------------------------------------------------------------------
 * Used to import styles for all customer templates.
 *
 */
import '@/templates/customers.scss'

import { vueReady } from '~/core/runners'

import CustomersHeader from '~/components/customers-header'

vueReady(() => {
  CustomersHeader().init()
})
